import React from 'react';
import '../styles/StatusBadge.css';

// Clientes usa valores acotados (ACTIVO, BLOQUEADO, INACTIVO); Créditos y
// Catálogos todavía guardan texto libre. Se cubren ambos: si el valor es
// conocido se muestra su etiqueta legible, si no, se muestra tal cual.
const ESTILOS = {
  activo: { tono: 'is-active', etiqueta: 'Activo' },
  bloqueado: { tono: 'is-blocked', etiqueta: 'Bloqueado' },
  inactivo: { tono: 'is-neutral', etiqueta: 'Inactivo' },
  aprobado: { tono: 'is-active', etiqueta: 'Aprobado' },
  pendiente: { tono: 'is-pending', etiqueta: 'Pendiente' },
  rechazado: { tono: 'is-blocked', etiqueta: 'Rechazado' },
  // Crédito V2 (Fase 5.0).
  borrador: { tono: 'is-pending', etiqueta: 'Borrador' },
  autorizado: { tono: 'is-active', etiqueta: 'Autorizado' },
  cancelado: { tono: 'is-blocked', etiqueta: 'Cancelado' },
  programada: { tono: 'is-pending', etiqueta: 'Programada' },
  retirado: { tono: 'is-neutral', etiqueta: 'Retirado' },
  // Agrupaciones de crédito (Fase 6.2).
  activa: { tono: 'is-active', etiqueta: 'Activa' },
  cancelada: { tono: 'is-blocked', etiqueta: 'Cancelada' },
  // Crédito V2, estado que Pagos V1 activa por primera vez (Fase 7.0).
  // "activo" ya existe arriba (Clientes) y sirve igual para Crédito.
  liquidado: { tono: 'is-active', etiqueta: 'Liquidado' },
  // Pagos V1 (Fase 7.0).
  aplicado: { tono: 'is-active', etiqueta: 'Aplicado' },
  reversado: { tono: 'is-blocked', etiqueta: 'Reversado' },
  // Cobertura y vencimiento de cuota, derivados (Fase 7.0, secciones 22-23).
  sin_pago: { tono: 'is-neutral', etiqueta: 'Sin pago' },
  parcial: { tono: 'is-pending', etiqueta: 'Parcial' },
  total: { tono: 'is-active', etiqueta: 'Total' },
  vigente: { tono: 'is-active', etiqueta: 'Vigente' },
  vencida: { tono: 'is-blocked', etiqueta: 'Vencida' },
  // Moratorios V1 (Fase 8.0), estado derivado del cargo.
  // "pendiente"/"cancelado" ya existen arriba y sirven igual aquí.
  pagado: { tono: 'is-active', etiqueta: 'Pagado' },
  // Cobranza V2 (Fase 9.0), situación de cartera derivada.
  al_corriente: { tono: 'is-active', etiqueta: 'Al corriente' },
  por_vencer: { tono: 'is-pending', etiqueta: 'Por vencer' },
  vencido: { tono: 'is-blocked', etiqueta: 'Vencido' },
  moratorio: { tono: 'is-blocked', etiqueta: 'Moratorio' },
  // GestionCobranza.resultadoGestion.
  contactado: { tono: 'is-active', etiqueta: 'Contactado' },
  no_contactado: { tono: 'is-neutral', etiqueta: 'No contactado' },
  promesa_pago: { tono: 'is-pending', etiqueta: 'Promesa de pago' },
  pago_reportado: { tono: 'is-pending', etiqueta: 'Pago reportado' },
  rechaza_pago: { tono: 'is-blocked', etiqueta: 'Rechaza pago' },
  reagendar: { tono: 'is-neutral', etiqueta: 'Reagendar' },
  // PromesaPago, estado derivado. "vigente"/"cancelada" ya existen arriba.
  cumplida: { tono: 'is-active', etiqueta: 'Cumplida' },
  cumplida_en_fecha: { tono: 'is-active', etiqueta: 'Cumplida en Fecha' },
  cumplida_tardia: { tono: 'is-active', etiqueta: 'Cumplida Tardía' },
  parcial_en_curso: { tono: 'is-pending', etiqueta: 'Parcial en Curso' },
  vencida_parcial: { tono: 'is-blocked', etiqueta: 'Vencida Parcial' },
  incumplida: { tono: 'is-blocked', etiqueta: 'Incumplida' },
  cerrada: { tono: 'is-neutral', etiqueta: 'Cerrada' },
  renegociada: { tono: 'is-neutral', etiqueta: 'Renegociada' },
  cumplimiento_afectado_por_reverso: { tono: 'is-blocked', etiqueta: 'Afectada por Reverso' }
};

function StatusBadge({ value }) {
  if (value === undefined || value === null || value === '') {
    return <span className="status-badge is-neutral">—</span>;
  }

  const bruto = String(value).trim();
  const conocido = ESTILOS[bruto.toLowerCase()];

  return (
    <span className={`status-badge ${conocido ? conocido.tono : 'is-neutral'}`}>
      <span className="status-dot" aria-hidden="true" />
      {conocido ? conocido.etiqueta : bruto}
    </span>
  );
}

export default StatusBadge;
